<section class="desk:centered-with-padding py-7">
  <div class="mb-5 px-5 desk:mb-8 desk:px-0">
    <app-title [title]="data.title" size="h2" />
  </div>

  <div class="no-scrollbar flex h-72 gap-x-4 overflow-x-scroll px-5 desk:grid desk:grid-cols-3 desk:gap-x-5 desk:px-0">
    @for (article of data.articles; track $index) {
      <a [routerLink]="article.url" class="w-11/12 shrink-0 desk:w-full">
        <app-option-card [image]="article.image" [isPriority]="!isImageInPreviousBlocks && $index < 3">
          <div card-subtitle-left>{{ article.category }}</div>
          <div card-subtitle-right>{{ article.date }}</div>
          <div card-title-left>{{ article.title }}</div>
          <div card-title-right>
            <app-svg [height]="16" [width]="25" src="assets/icons/arrow-right.svg" />
          </div>
        </app-option-card>
      </a>
    }
  </div>
</section>
